import React from 'react';
import If from '@components/shared/conditional/If/If';
import {
  isEmpty
} from 'lodash';
import classNames from 'classnames';
import {
  ISearchFilters,
  ISearchResults,
} from '@components/pages/ShopV3/model/SearchResults';
import FacetFilter from '../Filters/FacetFilter/FacetFilter';
import styles from './Sidebar.module.scss';
import AttributeFamilyFilters, {
  IAttributeFamilies,
} from '../Filters/AttributeFamilyFilter/AttributeFamilyFilters';
import { ShopPageType } from '../../model/ShopPage';

interface ISidebarProps {
  className?: string;
  filters: ISearchFilters;
  searchResults: ISearchResults;
  isExpanded: boolean;
  shopPageType: ShopPageType;
  attributeFamilies: IAttributeFamilies;
}

const Sidebar = ({
  className = '',
  filters: { selectedShopGroupChain = [], selectedMerchGroup },
  searchResults,
  isExpanded,
  shopPageType,
  attributeFamilies
}: ISidebarProps) => {
  const { attributeFamilyFilters, selectedFilterIds, onFilterSelected } = attributeFamilies;

  return (
    <div className={classNames(className, styles.Sidebar)}>
      <div className={styles.SidebarContent}>
        <div
          className={classNames(styles.Divider, {
            [styles.Transparent]: !isExpanded,
          })}
        />

        <If condition={
            shopPageType === ShopPageType.MERCH_GROUP ||
            shopPageType === ShopPageType.MERCH_GROUP_CATEGORY
          }
        >
          <div
            className={classNames({
              [styles.Transparent]: !isExpanded,
              [styles.Facets]: isExpanded,
            })}
          >
            <AttributeFamilyFilters
              attributeFamilyFilters={attributeFamilyFilters}
              selectedFilterIds={selectedFilterIds}
              onFilterSelected={onFilterSelected}
            />
          </div>
        </If>

        <If
          condition={
            !isEmpty(searchResults.facets) &&
            (!selectedMerchGroup || Number(selectedMerchGroup.id) === 290) && // todo: need constant
            !selectedShopGroupChain.length
          }
        >
          <div
            className={classNames({
              [styles.Transparent]: !isExpanded,
              [styles.Facets]: isExpanded,
            })}
          >
            <If condition={!!searchResults.facets?.price}>
              <FacetFilter facet={searchResults.facets.price} />
            </If>
            <If condition={!!searchResults.facets?.vendor}>
              <FacetFilter facet={searchResults.facets.vendor} />
            </If>
            <If condition={!!searchResults.facets?.category}>
              <FacetFilter facet={searchResults.facets.category} />
            </If>
          </div>
        </If>
      </div>
    </div>
  );
};

export default Sidebar;
